/* eslint-disable react/jsx-one-expression-per-line */
import React from 'react';

// The current method paper. `methodology.pdf` is the November 2023 document and
// describes the earlier method, which has been replaced -- it is deliberately left in
// place so existing links do not break, but it is NOT what this map now computes.
const WHITEPAPER_URL = 'https://wli.divirod.com/water-level-index-white-paper.pdf';

export default function AboutText() {
  return (
    <div className="about-text">
      <p>
        Explore Divirod&apos;s Water Level Index (WLI) Map for a visual representation of global
        water conditions based on real data, distinguishing it from model estimates. The map,
        continuously updated, categorizes water levels into five codes and provides insights into
        areas at risk of excess or scarcity. The methodology details can be found in
        <a target="_blank" rel="noreferrer" href={WHITEPAPER_URL}> this white paper</a>.
        For detailed data access, contact
        <a href="mailto:water.team@divirod.com"> water.team@divirod.com</a>.
      </p>
    </div>
  );
}
